module.exports = __webpack_public_path__ + "assets/img/b4-8.3fc471f2.png";